<template>
    <ul class="!static lg:!absolute menu z-1 lg:min-w-850">
        <ul
        class="bg-gray-50 dark:bg-base-300 lg:dark:!shadow-whiteShadow rounded-lg lg:shadow-nav-link pt-5 lg:mt-8 grid-cols-3 lg:p-4 lg:max-h-100 lg:overflow-y-auto scrollbar-small lg:grid">
        <li v-for="child in children" class="h-full lg:!static inline-block lg:flex w-full">
            <router-link :to="`/${child.slug}`" v-if="child.slug" active-class=""
                class="flex !bg-transparent text-sm font-bold text-biscay-700 dark:hover:text-gray-20 dark:text-white hover:text-gray-800 gap-0 py-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 ml-0.5">
                    <path fill-rule="evenodd"
                        d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                        clip-rule="evenodd" />
                </svg>
                {{ child.title }}
            </router-link>
        </li>
    </ul>
    </ul>
</template>
<script setup>
defineProps(['children']);
</script>